
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Enhance your checkout and reduce returns with Seamless ACH. Utilize Plaid's verification and real-time balance checks to instantly debit and credit bank accounts."
};
export const partnerProps = {
  partner: 'Seamless ACH',
  clientLibrary: 'seamlessach',
  subtitle: metadata.description,
  registrationUrl: 'https://dashboard.seamlesschex.com/ach/#/sign-up/partner/01JADWDHDFA6XRM1HG0V81KQ6F',
  apiUrl: 'https://developers-ach.seamlesschex.com/',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Seamless ACH and Plaid have partnered to enhance eCommerce ACH payments. Utilizing Plaid's verification technology,
businesses can easily authenticate and securely store customer bank details for direct ACH debits and credits.
All transactions processed through Seamless ACH benefit from Plaid's Balance check and Signal features, mitigating ACH
returns. Seamless ACH's versatile CheckoutJS and plugin options guarantee smooth integration into current checkout systems,
applications, and more. Additionally, Seamless ACH offers subscription management, expedited funding and instant payouts
through Real-Time Payments (RTP), streamlining the financial operations of any eCommerce business.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthSignalInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
